module.exports = __webpack_public_path__ + "img/zip.3d6157ee.png";